module.exports = "/assets/37eefd71f8b851bb9e5d62ec89959449.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BP.png
// module id = 1238
// module chunks = 0